var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44073_25094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0022 7.8269L36.5239 20.0008L20.0022 32.1747L3.48047 20.0008L20.0022 7.8269Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 26.9564C23.8414 26.9564 26.9559 23.8419 26.9559 19.9999C26.9559 16.158 23.8414 13.0435 19.9995 13.0435C16.1575 13.0435 13.043 16.158 13.043 19.9999C13.043 23.8419 16.1575 26.9564 19.9995 26.9564Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5229 19.5659C15.3132 19.5659 14.1458 19.7499 13.0469 20.0913C13.0955 23.8913 16.1896 26.9572 20.0012 26.9572C22.358 26.9572 24.4396 25.784 25.698 23.991C23.5451 21.2959 20.2325 19.5659 16.5229 19.5659Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8295 21.333C26.9133 20.9014 26.9585 20.4562 26.9585 20.0002C26.9585 16.1582 23.844 13.0437 20.002 13.0437C17.1353 13.0437 14.6744 14.7782 13.6094 17.2546C14.5508 17.0595 15.5255 16.9568 16.5238 16.9568C20.5642 16.9567 24.2194 18.6362 26.8295 21.333Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44073_25094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.8c882b4df7c55ff2a92c400a9a63a553.svg";
export { ForwardRef as ReactComponent };